import { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'

import { useAuth } from '../../hooks/useAuth'
import { CarritoContext } from '../context/carritoContext'
import {
  calcularTotalItemConIva,
  calcularTotalItemSinIva,
  toNumber
} from '../helpers/calcularPrecioTotal'
import { obtenerPresupuestoItems, obtenerPublicacion } from '../servicios/compraService'
import { buscarPorId } from '../servicios/usuarioService'
import PasarelaPago from './PasarelaPago'

const Compras = () => {
  const [itemsCompra, setItemsCompra] = useState([])
  const location = useLocation()
  const { loginDataContext: { idUsuario } = {} } = useAuth()

  const { idPresupuestoComprar, idPublicacionComprar, items, cantidadCompra } =
    useContext(CarritoContext)

  const obtenerUsuario = async (idUsuario) => {
    const { data: usuarioTemp } = await buscarPorId(idUsuario)
    return usuarioTemp
  }

  const obtenerVendedoresDelCarrito = async (items) => {
    const idsVendedores = [...new Set(items.map(({ idVendedor }) => idVendedor).filter(Boolean))]
    const vendedores = await Promise.all(
      idsVendedores.map(async (id) => [id, await obtenerUsuario(id)])
    )

    return new Map(vendedores)
  }

  const obtenerItems = async (idPresupuestoComprar, idPublicacionComprar, items) => {
    if (!idUsuario) return
    //si viene de presupuestos
    if (idPresupuestoComprar > 0) {
      const { data } = await obtenerPresupuestoItems(idUsuario, idPresupuestoComprar)
      setItemsCompra(data)
    }
    //si viene de publicaciones
    else if (idPublicacionComprar > 0) {
      const { data: itemsTemp } = await obtenerPublicacion(idUsuario, idPublicacionComprar)
      const pub = itemsTemp[0]
      const detalleState = location.state?.detalle || {}
      const preciosMayoristasState =
        detalleState?.preciosMayoristas ||
        detalleState?.preciosMayorista ||
        location.state?.preciosMayorista ||
        location.state?.preciosMayoristas ||
        []
      const pubConMayoristas = {
        ...pub,
        preciosMayoristas:
          Array.isArray(pub?.preciosMayoristas) && pub.preciosMayoristas.length > 0
            ? pub.preciosMayoristas
            : preciosMayoristasState
      }
      const usrVendedor = await obtenerUsuario(pub.idVendedor)

      const porcDcto = Number(pub.porcDcto || location.state?.porcDcto) || 0
      const tieneDescuento = Boolean(location.state?.tieneDescuento || porcDcto > 0)

      const obtenerPrecioMayorista = (item, cantidad) => {
        let lista = []
        if (Array.isArray(item.preciosMayoristas) && item.preciosMayoristas.length > 0) {
          lista = item.preciosMayoristas
        } else if (Array.isArray(item.preciosMayorista) && item.preciosMayorista.length > 0) {
          lista = item.preciosMayorista
        } else if (item.precioUnitarioMayorista && item.cantidadMayorista) {
          lista = [
            {
              cantidad: item.cantidadMayorista,
              precioUnitario: item.precioUnitarioMayorista
            }
          ]
        }

        if (!lista.length) {
          return null
        }
        const tiers = lista
          .map((p) => ({
            cantidad: toNumber(p.cantidad),
            precioUnitario: toNumber(p.precioUnitario || p.precio)
          }))
          .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)
          .sort((a, b) => b.cantidad - a.cantidad)
        return tiers.find((t) => cantidad >= t.cantidad) || null
      }

      const tier = obtenerPrecioMayorista(pubConMayoristas, cantidadCompra)
      const precioBase = tier ? tier.precioUnitario : toNumber(pub.precioUnitario)

      setItemsCompra([
        {
          ...pubConMayoristas,
          precioUnitario: precioBase,
          precioUnitarioSinDescuento: precioBase,
          porcDcto,
          tieneDescuento,
          ...location.state.imputacion,
          alicuota:
            items.filter((item) => item.idPublicacion === pub.idPublicacion)[0]?.alicuota ||
            pub.alicuota,
          cantidad: cantidadCompra,
          ...usrVendedor,
          idVendedor: pub.idVendedor,
          valorTotalSinIva: calcularTotalItemSinIva({
            precioUnitario: precioBase,
            porcDcto,
            cantidad: cantidadCompra
          }),
          valorTotalConIva: calcularTotalItemConIva({
            precioUnitario: precioBase,
            porcDcto,
            cantidad: cantidadCompra,
            alicuota:
              items.filter((item) => item.idPublicacion === pub.idPublicacion)[0]?.alicuota ||
              pub.alicuota
          }),
          mediosPagos: location.state?.publicaciones?.[0].mediosPagos || []
        }
      ])
    }
    //si viene del carrito
    else if (items.length > 0 && idPublicacionComprar === 0 && idPresupuestoComprar === 0) {
      const vendedoresMap = await obtenerVendedoresDelCarrito(items)
      setItemsCompra(
        items.map((item) => {
          const usrVendedor = vendedoresMap.get(item.idVendedor) || {}
          return {
            ...item,
            ...usrVendedor,
            idVendedor: item.idVendedor,
            valorTotalSinIva: calcularTotalItemSinIva(item),
            valorTotalConIva: calcularTotalItemConIva(item)
          }
        })
      )
    }
  }

  useEffect(() => {
    obtenerItems(idPresupuestoComprar, idPublicacionComprar, items)
  }, [idPresupuestoComprar, idPublicacionComprar, idUsuario])

  return <PasarelaPago itemsCompra={itemsCompra} />
}

export default Compras
